import type {RouteRecordRaw} from 'vue-router';

import {route as personalAccount} from './cabinet';
import {route as mainPage, routeName as mainName} from './main';
import {route as externalDocPage} from './externalDoc';
import {route as mainValidate} from './validate';
import {route as mainValidateById} from './validate_by_id';
import {route as promocodeRedirect} from './promocode';
import {route as localeRedirect} from './locale';
import {route as surveyPage} from './survey';

export const routes: readonly RouteRecordRaw[] = [
    {
        path: '/',
        name: 'root',
        redirect: {
            name: mainName
        },
        children: [
            mainPage,
            promocodeRedirect,
            localeRedirect,
            surveyPage,
            {
                path: '/',
                name: 'main-layout',
                component: () => import('@/app/layouts/MainLayout'),
                children: [
                    externalDocPage,
                    mainValidate,
                    mainValidateById,
                ]
            },
            personalAccount,
            {
                path: '/:pathMatch(.*)*',
                name: 'NotFound',
                component: () => import('@/app/layouts/MainLayout'),
                children: [
                    {
                        path: '',
                        name: 'NotFoundChild',
                        component: () => import("@/pages/NotFound"),
                    }
                ]
            },
        ]
    },
] as const;
